import React from "react";
import "./SponsorsSec.scss";
import CountLogo from "../../assets/images/sponsors/count-logo.webp";
import NotAllTalkLogo from "../../assets/images/sponsors/not-all-talk-logo.png";
import OfficeOfSocialJusticeLogo from "../../assets/images/sponsors/osj-logo.png";
import RotaryLogo from "../../assets/images/sponsors/rotary-logo.png";
import AceLogo from "../../assets/images/sponsors/Ace-Logo.png";
import CascadiaLogo from "../../assets/images/sponsors/Cascadia-logo.png";
import SherwinLogo from "../../assets/images/sponsors/sherwin-logo.png";
import LakeStevinsLogo from "../../assets/images/sponsors/lake-stevens-logo.jpg";
import FoodBankLogo from "../../assets/images/sponsors/food-bank-logo.avif";
import CityLakeLogo from "../../assets/images/sponsors/city-lake-logo.jpg";
import BlosLogo from "../../assets/images/sponsors/blos-logo.avif";
import FilmFestivalLogo from "../../assets/images/sponsors/film-festival-logo.webp";
import PhotographyLogo from "../../assets/images/sponsors/photography-logo.jpg";
import FarmersLogo from "../../assets/images/sponsors/farmers-logo.jpg";
import SnohomishLogo from "../../assets/images/sponsors/snohomish-logo.png";

const SponsorsSec = () => {
  return (
    <section className="sponsorsSec">
      <div id="sponsors" className="sponsorsSec_idBox" />
      <div className="container">
        <div className="sponsorsSec_donors">
          <h4>Special Thanks to Creator Zone Donors:</h4>
          <div className="sponsorsSec_donorsBox">
            <img src={CountLogo} alt="count" className="col-span-2" />
            <div className="col-span-1" />
            <img src={NotAllTalkLogo} alt="count" className="col-span-3" />
            <img
              src={OfficeOfSocialJusticeLogo}
              alt="count"
              className="col-span-2"
            />
            <img src={RotaryLogo} alt="count" className="col-span-2" />
            <img src={AceLogo} alt="count" className="col-span-2" />
            <img src={CascadiaLogo} alt="count" className="col-span-2" />
            <div className="col-span-2">
              <img src={SherwinLogo} alt="count" className="" />
              <img src={LakeStevinsLogo} alt="count" className="" />
            </div>
            <div className="col-span-2 sponsorsSec_specialMentionText">
              <h5>Special Metion to:</h5>
              <p> Dave and Tracy DeLorm</p>
              <p>Christine Egelstad</p>
              <p>Michael Brown and Laurie Havanec</p>
              <p>Andrew and Brandee Cederlind</p>
              <p>Roma’s Serger University</p>
              <p>Mike Westover </p>
              <p>S&D Miller LLC</p>
            </div>
          </div>
        </div>

        <div className="sponsorsSec_supporters">
          <h4>
            Thank you to our community partners for your continued support!
          </h4>
          <div className="sponsorsSec_supportersBox">
            <img src={FoodBankLogo} alt="count" className="col-span-2" />
            <img src={CityLakeLogo} alt="count" className="col-span-2" />
            <img src={BlosLogo} alt="count" className="col-span-2" />
            <img src={FilmFestivalLogo} alt="count" className="col-span-2" />
            <img src={PhotographyLogo} alt="count" className="col-span-2" />
            <img src={FarmersLogo} alt="count" className="col-span-2" />
            <img src={SnohomishLogo} alt="count" className="col-span-2" />
            <div className="col-span-6 sponsorsSec_specialMentionText">
              <p>
                Plus many more induviudals & volunteers who offer their time and
                expertise, we appreciate you & the positive impact you help
                create in the community!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSec;
